import React, { useEffect, useState } from 'react';
import CustomContent from '../../../components/Content/CustomContent';
import { deleteData, fetchData, saveData } from '../../service/dataServices';
import { Col, Divider, Row, Select, Space, Tabs, Button, Checkbox, Form, Input, InputNumber } from 'antd';
import { getLocalizedTitle } from '../../utils/localization';
import AddressTab from './AddressTab';
import { useTranslation } from 'react-i18next';
const { Option } = Select;

const Settings = () => {

  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  fetchData('/api/dropdowns/categories', response => setCategories(response));
  fetchData('/api/settings/categories/' + selectedCategory?.id, response => form.setFieldsValue(response), null, selectedCategory !== null)

  const [form] = Form.useForm();
  const saveMutation = saveData('/api/settings/categories', 'POST');

  const onSelect = (val) => {
    if (val && val !== '') {
      const found = categories.find(d => d.title === val);
      setSelectedCategory(found);
    } else {
      setSelectedCategory(null);
    }
  };

  const convertCamelCaseToSentence = (text) => {
    if (text) {
      const result = text.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    }
    return "";
  };

  const onFinish = result => {
    const dataToSend = { id: selectedCategory?.id, prefix: result.prefix, firstNumber: result.firstNumber, currentNumber: result.firstNumber }
    console.log('DataToSend:', dataToSend);

    saveMutation.mutate({ dataToSend }, { onSuccess: () => setSelectedCategory(null) });
  };
  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const categorySettings = (
    <>
      <Row>
        <Space direction="horizontal" style={{ width: '100%' }} wrap>
          {t('settings.selectCategory')}
          <Select
            showSearch
            filterOption
            optionFilterProp="children"
            placeholder={t('settings.selectCategoryType')}
            value={selectedCategory?.title}
            allowClear
            style={{ width: '25vh' }}
            onSelect={onSelect}
            onClear={() => {
              setSelectedCategory(null);
            }}
          >
            {
              categories?.map(option => (
                <Option
                  value={option.title}
                  key={option.title}
                >
                  {convertCamelCaseToSentence(getLocalizedTitle(option))}
                </Option>
              ))
            }
          </Select>
        </Space>
      </Row>
      <Divider />
      <Row>
        {selectedCategory && <Form
          name="basic"
          labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          style={{ width: '100%' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label={t('settings.prefix')}
            name="prefix"
            rules={[{ required: true, message: t('settings.pleaseInputPrefix') }]}
          >
            <Input style={{ maxWidth: 200 }} />
          </Form.Item>

          <Form.Item
            label={t('settings.firstNumber')}
            name="firstNumber"
            rules={[{ required: true, message: t('settings.pleaseInputFirstNumber') }]}
          >
            <InputNumber min={1} />
          </Form.Item>

          <Form.Item
            label={t('settings.currentNumber')}
            name="currentNumber"
          >
            <InputNumber disabled={true} />
          </Form.Item>

          <Form.Item label={null}>
            <Button type="primary" htmlType="submit">
              {t('common.submit')}
            </Button>
          </Form.Item>
        </Form>}
      </Row>
    </>
  )

  const items = [
    {
      key: 'category',
      label: t('settings.category'),
      children: categorySettings,
    },
    {
      key: 'address',
      label: t('settings.address'),
      children: <AddressTab />,
    },
  ];

  return (
    (<CustomContent>
      <Tabs defaultActiveKey="category" items={items} tabPosition='left' />
    </CustomContent>)
  );
};

export default Settings;
